import { usePagination as useBasePagination } from "@nosto/search-js/preact/hooks"

export type Page = {
    from: number
    page: number
    current: boolean
}

/**
 * Preact hook that import pagination state to the component.
 *
 * **Should always be at the top of the component!**
 *
 * @example
 * ```jsx
 * import { usePagination } from '@nosto/preact'
 *
 * export default () => {
 *     const { pages } = usePagination()
 *
 *     return pages.map((page) => <li>
 *         {page.current ? <span>{page.page}</span> : <a>
 *             {page.page}
 *         </a>}
 *     </li>)
 * }
 * ```
 *
 * @group Hooks
 */
export function usePagination(options?: { width?: number }): {
    totalPages: number
    resultsFrom: number
    resultsTo: number
    current?: Page
    prev?: Page
    next?: Page
    first?: Page
    last?: Page
    pages: Page[]
} {
    return useBasePagination(options)
}
